import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Button,
  Spinner,
  Input,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import * as yup from 'yup';
import { toast } from 'react-toastify';
// import { LOGIN_MODEL } from "pages/Login/constant";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ForgotPassword: React.FC = () => {
  const [loginCreds, setLoginCreds] = useState<{ email: string }>({
    email: '',
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({
    email: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPasswordStep, setIsPasswordStep] = useState(false);
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(''));
  const [timeRemaining, setTimeRemaining] = useState<number>(120);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const navigate = useNavigate();

  const handleOtpChange = (e: any, index: any) => {
    const { value } = e.target;
    console.log('OTP', value);

    if (/^[0-9a-zA-Z]*$/.test(value) && value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      console.log('OTP jsnadlj', newOtp);

      // Move to the next input if the current input is filled
      if (value) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const validationSchema = yup.object({
    email: yup
      .string()
      .email('Invalid email format')
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Invalid email format')
      .required('Email is required'),
    newPassword: yup
      .string()
      .required('New Password is required')
      .min(6, 'Password must be at least 6 characters long'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('newPassword'), undefined], 'Passwords must match')
      .required('Confirm Password is required'),
  });

  useEffect(() => {
    validationSchema
      .validateAt('email', { email: loginCreds.email })
      .then(() => setIsEmailValid(true))
      .catch(() => setIsEmailValid(false));
  }, [loginCreds.email, validationSchema]);

  useEffect(() => {
    if (isPasswordStep && timeRemaining > 0) {
      const timer = setInterval(() => {
        setTimeRemaining((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isPasswordStep, timeRemaining]);
  useEffect(() => {
    if (timeRemaining === 0) {
      setIsResendDisabled(false);
    }
  }, [timeRemaining]);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;

    if (name === 'newPassword' || name === 'confirmPassword') {
      if (touched[name]) {
        validationSchema
          .validateAt(name, { newPassword, confirmPassword, [name]: value })
          .then(() => setErrors((prev) => ({ ...prev, [name]: '' })))
          .catch((err) =>
            setErrors((prev) => ({ ...prev, [name]: err.message }))
          );
      }

      if (name === 'newPassword') setNewPassword(value);
      if (name === 'confirmPassword') setConfirmPassword(value);
    } else {
      setLoginCreds((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));

    validationSchema
      .validateAt(name, {
        email: loginCreds.email,
        newPassword,
        confirmPassword,
      })
      .then(() => {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      })
      .catch((err) => {
        setErrors((prev) => ({ ...prev, [name]: err.message }));
      });
  };

  const handleSubmitEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await validationSchema.validateAt('email', loginCreds);

      const response = await axios.post(
        'https://dev-auth-api.dyo.world/v1.0/auth/forgotPassword',
        { email: loginCreds.email }
      );
      if (response.data.success === true) {
        toast.success('Email sent successfully. Please check your inbox.');
        setIsPasswordStep(true);
        setTimeRemaining(120);
        console.log('response for otp', response.data.data.otp);
      }
    } catch (error) {
      toast.error('Invalid email.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmitPassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        'https://dev-auth-api.dyo.world/v1.0/auth/forgotPassword/newPassword',
        { password: newPassword, confirmPassword },

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('response...', response);
      toast.success('Your password has been reset successfully.');
      navigate('/app/dashboard', { state: { heading: 'Dashboard' } });
    }catch (err: unknown) {
  let message = "Something went wrong.";

  if (axios.isAxiosError(err)) {
    message = err.response?.data?.message || message;
  }

  toast.error(message);
} finally {
  setIsSubmitting(false);
}
  };

  const handleResendOtp = async () => {
    const response = await axios.post(
      'https://dev-auth-api.dyo.world/v1.0/auth/forgotPassword',
      { email: loginCreds.email }
    );
    if (response.data.success === true) {
      toast.success('A new OTP has been sent to your registered email.');
      setIsPasswordStep(true);
      setTimeRemaining(120);
      console.log('response for otp', response.data.data.otp);
    }
    if (isResendDisabled) return;
    setIsSubmitting(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setTimeRemaining(120);
      setIsResendDisabled(true);
    } catch (error) {
      toast.error('Failed to resend OTP. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isOtpValid = otp.every((digit) => digit !== '');

  const handleVerifyOtp = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('45646546', otp.join(''));

    try {
      const response = await axios.post(
        'https://dev-auth-api.dyo.world/v1.0/auth/forgotPassword/validate/otp',
        {
          otp: otp.join(''),
          email: loginCreds.email,
        }
      );

      if (response.data.success === true) {
        setIsOtpVerified(true);
        localStorage.setItem('accessToken', response.data.data.accessToken);
        localStorage.setItem('email', response.data.data.email);
        console.log(',,,,,,,,,,,', localStorage.getItem('accessToken'));
        console.log('email set local storage..', response.data.data.email);

        toast.success('OTP Verified Successfully.');
        console.log('dfghjkjh', response.data);
      } else {
        toast.error('Invalid OTP.');
      }
    } catch (error) {
      toast.error('Error verifying OTP.');
    }
  };

  return (
    <Row className="getway-wrapper login-page">
      <Col md="6" className="bg-light-gray login-form-container">
        {!isPasswordStep ? (
          <div>
            <h2 className="text-center mb-4">Forgot Password</h2>
            <form onSubmit={handleSubmitEmail}>
              <FormGroup className="d-flex flex-column">
                <label className="form-label">Email</label>
                {errors.email && (
                  <small className="text-danger mb-0">{errors.email}</small>
                )}
                <Input
                  type="email"
                  name="email"
                  value={loginCreds.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={`form-control ${
                    touched.email && errors.email ? 'is-invalid' : ''
                  }`}
                  placeholder="Enter your email"
                />
                <Row className="align-items-center gap-4">
                  <Button
                    type="submit"
                    className="button login-button"
                    disabled={isSubmitting || !isEmailValid}
                  >
                    {isSubmitting ? <Spinner size="sm" /> : 'Submit'}
                  </Button>
                </Row>
              </FormGroup>
            </form>
          </div>
        ) : isOtpVerified ? (
          <div>
            <h2 className="text-center mb-4">Reset Password</h2>
            <form onSubmit={handleSubmitPassword}>
              <FormGroup className="d-flex flex-column">
                <label className="form-label">New Password</label>
                {errors.newPassword && (
                  <small className="text-danger mb-0">
                    {errors.newPassword}
                  </small>
                )}
                <InputGroup className="input-box">
                  <Input
                    className={`form-control ${
                      touched.newPassword && errors.newPassword
                        ? 'is-invalid'
                        : ''
                    }`}
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter your new password"
                    name="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onBlur={handleBlur}
                    required
                  />
                  <InputGroupText>
                    <button
                      className="password-button"
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword ? 'Show password' : 'Hide password'
                      }
                    >
                      {showPassword ? (
                        <i className="bi bi-eye-slash"></i>
                      ) : (
                        <i className="bi bi-eye"></i>
                      )}
                    </button>
                  </InputGroupText>
                </InputGroup>

                <label className="form-label">Confirm Password</label>
                {errors.confirmPassword && (
                  <small className="text-danger mb-0">
                    {errors.confirmPassword}
                  </small>
                )}
                <InputGroup className="input-box">
                  <Input
                    className={`form-control ${
                      touched.confirmPassword && errors.confirmPassword
                        ? 'is-invalid'
                        : ''
                    }`}
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="Confirm your new password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onBlur={handleBlur}
                    required
                  />
                  <InputGroupText>
                    <button
                      className="password-button"
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      aria-label={
                        showConfirmPassword ? 'Show password' : 'Hide password'
                      }
                    >
                      {showConfirmPassword ? (
                        <i className="bi bi-eye-slash"></i>
                      ) : (
                        <i className="bi bi-eye"></i>
                      )}
                    </button>
                  </InputGroupText>
                </InputGroup>

                <Button
                  type="submit"
                  className="button login-button"
                  disabled={
                    !newPassword ||
                    !confirmPassword ||
                    newPassword.length < 6 ||
                    confirmPassword.length < 6 ||
                    isSubmitting
                  }
                >
                  {isSubmitting ? <Spinner size="sm" /> : 'Reset Password'}
                </Button>
              </FormGroup>
            </form>
          </div>
        ) : (
          <div>
            <h2 className="text-center mb-4">Email Verification</h2>
            <h6>
              If <span style={{ color: 'red' }}>{loginCreds.email}</span> is
              registered, we'll send an OTP to your inbox right away!
            </h6>
            <h6 className="text-center">
              Time Remaining:{' '}
              <span style={{ color: 'red' }}>{formatTime(timeRemaining)}</span>{' '}
            </h6>
            <form onSubmit={handleVerifyOtp}>
              <FormGroup className="d-flex justify-content-around mt-3">
                {Array.from({ length: 6 }).map((_, index) => (
                  <Input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    maxLength={1}
                    className="otp-input"
                    value={otp[index] || ''}
                    onChange={(e) => handleOtpChange(e, index)}
                    onFocus={(e) => e.target.select()}
                    style={{ width: '40px', textAlign: 'center' }}
                  />
                ))}
              </FormGroup>
              <Button
                type="submit"
                className="button"
                style={{ width: '100%' }}
                disabled={!isOtpValid || isSubmitting}
                // onClick={handleVerifyOtp}
              >
                {isSubmitting ? <Spinner size="sm" /> : 'Verify Account'}
              </Button>
            </form>
            <h6 className="mt-2">
              Didn't receive the code?{' '}
              <Button
                color="link"
                onClick={handleResendOtp}
                disabled={isResendDisabled}
              >
                Resend OTP
              </Button>
            </h6>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default ForgotPassword;
